import classNames from 'classnames'

import styles from './TextArea.module.scss'

export const TextArea = (props: any): JSX.Element => (
	<textarea {...props} className={classNames(props.className, styles.textArea)} />
)
